import { FeatureFlagNameEnum } from "@/services/internalApiV1";
import type { RouteLocationRaw, RouteRecordRaw } from "vue-router";

// The production to-teach account's tools user id: the "to teach" partner in
// the gallery's partner filter. Hard-coded on purpose, it never changes and
// this keeps it out of the API. Other environments have a different id; the
// gallery drops a partner it doesn't list, so there the filter stays empty.
export const TO_TEACH_TOOLS_USER_ID = "5d0aa721-9e57-4495-b854-fe47238b9a2c";

// With the to-teach catalog flag, to-teach content lives in the main gallery
// (docs/exec-plans/to-teach-gallery-catalog.md, D5), so the old link-out tab
// sends teachers there, with the "to teach" partner selected and sorted by
// relevance, which lists the to-teach collections first (sorted by newest,
// the most recent worksheets would come first instead). Flag off, the
// tab stays. The user is seeded from `data-user` in `main.ts`, so this
// answers synchronously.
export function toTeachCatalogRedirect(): true | RouteLocationRaw {
  const userStore = useUserStore();
  if (
    !userStore.isFeatureEnabled(FeatureFlagNameEnum.TO_TEACH_GALLERY_CATALOG)
  ) {
    return true;
  }

  return {
    name: "gallery-index",
    query: { order: "relevant", userIds: [TO_TEACH_TOOLS_USER_ID] },
  };
}

export const galleryRoutes: RouteRecordRaw[] = [
  {
    path: "/gallery",
    component: () => import("../GalleryLayout.vue"),
    children: [
      {
        path: "",
        name: "gallery-index",
        component: () => import("./GalleryListPage.vue"),
      },
      {
        path: "community",
        name: "gallery-community",
        component: () => import("./community.vue"),
      },
      {
        path: "to_teach",
        name: "gallery-to-teach",
        component: () => import("./to_teach.vue"),
        beforeEnter: toTeachCatalogRedirect,
      },
    ],
  },
  {
    path: "/gallery/how_to",
    name: "gallery-how-to",
    component: () => import("../gallery.how_to.vue"),
  },
];
